// TODO: Make this selected by the environment and not parsing the URL

type EnvironmentType = "LOCAL" | "DEV_AZURE" | "STAGING" | "PROD_EU" | "PROD_US" | "PROD_AUS" | "PROD_AP"

interface EnvironmentVariables {
  urlMatch?: string
  quadriSettingsApiUrl: string
  quadriGraphQlUrl: string
  showUserPermissions?: boolean
  envName?: string
  allowPurge: boolean
  hideRawErrorMessages?: boolean
  featureFlagUseRestApi?: boolean
  enforceExtensionActivationAndRemovalPolicy?: boolean
  enforceRegionPolicy?: boolean
  region?: string
  enableEditExtensionOwnership?: boolean
  enableObjectModelConfig?: boolean
  connectWebUrl: string
  enableNewCommonUi?: boolean
}

type EnviromentVariablesMap = {
  [key in EnvironmentType]: EnvironmentVariables
}

const Environments: EnviromentVariablesMap = {
  LOCAL: {
    quadriSettingsApiUrl: "https://settings-az.quadri.cc/",
    quadriGraphQlUrl: "https://graphql-az.quadri.cc/graphql",
    //quadriGraphQlUrl: "http://localhost/graphql", // REJECT PR IF THIS IS NOT COMMENTED!
    urlMatch: "localhost",
    showUserPermissions: true,
    envName: "Local (Az)",
    allowPurge: true,
    region: "northAmerica",
    enforceExtensionActivationAndRemovalPolicy: true,
    enforceRegionPolicy: true,
    connectWebUrl: "https://web.stage.connect.trimble.com",
    enableObjectModelConfig: true,
    enableNewCommonUi: true
  },
  DEV_AZURE: {
    quadriSettingsApiUrl: "https://settings-az.quadri.cc/",
    quadriGraphQlUrl: "https://graphql-az.quadri.cc/graphql",
    urlMatch: "model-server-az.quadri.cc",
    showUserPermissions: true,
    envName: "Dev (Az)",
    allowPurge: true,
    featureFlagUseRestApi: true,
    enforceExtensionActivationAndRemovalPolicy: true,
    enforceRegionPolicy: true,
    region: "northAmerica",
    connectWebUrl: "https://web.stage.connect.trimble.com",
    enableEditExtensionOwnership: true,
    enableObjectModelConfig: true,
    enableNewCommonUi: true
  },
  STAGING: {
    quadriSettingsApiUrl: "https://settings.az.quadri-stg.trimble.com/",
    quadriGraphQlUrl: "https://graphql.az.quadri-stg.trimble.com/graphql",
    urlMatch: "quadri-stg.trimble.com",
    showUserPermissions: true,
    envName: "Stg",
    allowPurge: false,
    hideRawErrorMessages: true,
    enforceExtensionActivationAndRemovalPolicy: true,
    enforceRegionPolicy: true,
    region: "europe",
    connectWebUrl: "https://web.connect.trimble.com",
    enableObjectModelConfig: true,
    enableNewCommonUi: true
  },
  PROD_EU: {
    quadriSettingsApiUrl: "https://settings.quadri.trimble.com/",
    quadriGraphQlUrl: "https://graphql.az.quadri.trimble.com/graphql",
    urlMatch: "quadri.trimble.com",
    showUserPermissions: true,
    allowPurge: false,
    hideRawErrorMessages: true,
    enforceExtensionActivationAndRemovalPolicy: true,
    enforceRegionPolicy: true,
    region: "europe",
    connectWebUrl: "https://web.connect.trimble.com",
    enableObjectModelConfig: true,
    enableNewCommonUi: true
  },
  PROD_US: {
    quadriSettingsApiUrl: "https://settings.quadri.trimble.com/",
    quadriGraphQlUrl: "https://graphql.az.quadri-us.trimble.com/graphql",
    urlMatch: "quadri-us.trimble.com",
    showUserPermissions: true,
    allowPurge: false,
    hideRawErrorMessages: true,
    enforceExtensionActivationAndRemovalPolicy: true,
    enforceRegionPolicy: true,
    region: "northAmerica",
    connectWebUrl: "https://web.connect.trimble.com",
    enableObjectModelConfig: true,
    enableNewCommonUi: true
  },
  PROD_AUS: {
    quadriSettingsApiUrl: "https://settings.quadri.trimble.com/",
    quadriGraphQlUrl: "https://graphql.az.quadri-aus.trimble.com/graphql",
    urlMatch: "quadri-aus.trimble.com",
    showUserPermissions: true,
    allowPurge: false,
    hideRawErrorMessages: true,
    enforceExtensionActivationAndRemovalPolicy: true,
    enforceRegionPolicy: true,
    region: "australia",
    connectWebUrl: "https://web.connect.trimble.com",
    enableObjectModelConfig: true,
    enableNewCommonUi: true
  },
  PROD_AP: {
    quadriSettingsApiUrl: "https://settings.quadri.trimble.com/",
    quadriGraphQlUrl: "https://graphql.az.quadri-ap.trimble.com/graphql",
    urlMatch: "quadri-ap.trimble.com",
    showUserPermissions: true,
    allowPurge: false,
    hideRawErrorMessages: true,
    enforceExtensionActivationAndRemovalPolicy: true,
    enforceRegionPolicy: true,
    region: "asia",
    connectWebUrl: "https://web.connect.trimble.com",
    enableObjectModelConfig: true,
    enableNewCommonUi: true
  }
}

const initializeEnvironment = (specifyEnvironment?: EnvironmentType): EnvironmentVariables => {
  if (specifyEnvironment) {
    return Environments[specifyEnvironment]
  } else {
    console.log("Using url to match the environment")
    // If no region is specified, then find the environment based on URL
    const environmentMatch = Object.values(Environments).find(
      (env) => env.urlMatch && window.location.origin.includes(env.urlMatch)
    )
    return environmentMatch || Environments.DEV_AZURE
  }
}

// If environment needs to be overridden and not detected, do it here
// let Environment = initializeEnvironment()
// let Environment = getEnvironment("PROD_US")

// console.log("environment = ", Environment)

let Environment = initializeEnvironment()

const GetEnvironment = () => {
  // console.log("returning environment: ", Environment)
  return Environment
}

export const SetEnvironmentProdEU = () => {
  if (Environment === Environments.PROD_EU || Environment === Environments.PROD_US) {
    console.info("Using project region. Setting environment to PROD EU")
    Environment = Environments.PROD_EU
  } else {
    Environment = initializeEnvironment()
  }
}

export const SetEnvironmentProdUS = () => {
  if (Environment === Environments.PROD_EU || Environment === Environments.PROD_US) {
    console.info("Using project region. Setting environment to PROD US")
    Environment = Environments.PROD_US
  } else {
    Environment = initializeEnvironment()
  }
}

export const SetEnvironmentProdAUS = () => {
  if (
    Environment !== Environments.PROD_EU ||
    Environment !== Environments.PROD_US ||
    Environment !== Environments.STAGING
  ) {
    // TODO: Change when going to prod
    console.info("Using project region. Setting environment to PROD AUS")
    Environment = Environments.PROD_AUS
  } else {
    Environment = initializeEnvironment()
  }
}

export const SetEnvironmentProdAP = () => {
  if (
    Environment !== Environments.PROD_EU ||
    Environment !== Environments.PROD_US ||
    Environment !== Environments.PROD_AUS ||
    Environment !== Environments.STAGING
  ) {
    // TODO: Change when going to prod
    console.info("Using project region. Setting environment to PROD AP")
    Environment = Environments.PROD_AP
  } else {
    Environment = initializeEnvironment()
  }
}

export const SetEnvironmentDefault = () => {
  Environment = initializeEnvironment()
}

export default GetEnvironment
